import { render, staticRenderFns } from "./EiRms.vue?vue&type=template&id=64666c81&scoped=true&"
import script from "./EiRms.vue?vue&type=script&lang=js&"
export * from "./EiRms.vue?vue&type=script&lang=js&"
import style0 from "./EiRms.vue?vue&type=style&index=0&id=64666c81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64666c81",
  null
  
)

component.options.__file = "EiRms.vue"
export default component.exports